import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import React from 'react';
import Switch from '@material-ui/core/Switch';

interface IToggle {
    checked: boolean;
    onChange: any;
    name: string;
}
const SimpleToggle = ({ checked, name, onChange }: IToggle) => {
    return (
        <FormControl component="fieldset">
            <FormGroup>
                <Switch
                    checked={checked}
                    name={name}
                    onChange={onChange}
                    onClick={(e: any) => {
                        e.preventDefault();
                        e.stopPropagation();
                    }}
                    value={true}
                />
            </FormGroup>
        </FormControl>
    );
};

export default SimpleToggle;
